import { render, staticRenderFns } from "./MultiTranslatedTextField.vue?vue&type=template&id=299a1cd9&"
import script from "./MultiTranslatedTextField.vue?vue&type=script&lang=ts&"
export * from "./MultiTranslatedTextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports